import * as React from "react";
import type { SVGProps } from "react";
const SvgIconShare = (props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 16 16"
    fill="none"
    role="img"
    focusable="false"
    width="100%"
    height="100%"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.83.55 7.7.61 6.51 1.78C5.44 2.86 5.38 2.92 5.35 3.01c-.05.13-.05.3 0 .42.04.12.17.25.29.31.07.04.1.04.23.04.26 0 .25.01.95-.69l.6-.6v4.14c.01 3.9.01 4.15.04 4.21q.1.26.35.35c.09.03.29.03.38 0 .15-.05.29-.2.35-.35.03-.06.03-.31.03-4.2V2.48l.61.6c.67.67.69.68.9.7q.3 0 .48-.2c.13-.15.16-.39.1-.58-.04-.09-.1-.15-1.17-1.23C8.87 1.16 8.33.63 8.29.61c-.12-.08-.31-.1-.46-.06M3.08 4.78q-.36.04-.63.32c-.16.16-.24.3-.29.5-.03.11-.03.19-.03 4.52 0 4.76 0 4.5.08 4.69.1.23.32.45.55.56.24.1-.17.1 5.24.1s5 0 5.24-.1c.23-.11.46-.35.55-.57.09-.2.08.05.08-4.68 0-4.34 0-4.4-.03-4.53-.05-.2-.13-.33-.29-.49-.11-.12-.16-.15-.29-.21l-.23-.1c-.1-.02-1.74-.03-1.9-.01q-.21.03-.35.16c-.28.29-.2.75.18.93l.09.04h.84l.85.01v8.4H3.26v-8.4h.85l.84-.01.1-.04c.23-.12.37-.36.33-.61q-.03-.19-.16-.32-.14-.13-.33-.16c-.12-.02-1.65-.01-1.8 0"
      fill="currentColor"
    />
  </svg>
);
export default SvgIconShare;
